import { safeProbe as o } from "./safe.js";
var n = function(t) {
  if (t === void 0 && (t = document), !(!t || !t.activeElement)) {
    var e = t.activeElement;
    return e.shadowRoot ? n(e.shadowRoot) : e instanceof HTMLIFrameElement && o(function() {
      return e.contentWindow.document;
    }) ? n(e.contentWindow.document) : e;
  }
};
export {
  n as getActiveElement
};
